import { render, staticRenderFns } from "./CardCreateSlugError.vue?vue&type=template&id=77341d86&scoped=true&"
import script from "./CardCreateSlugError.vue?vue&type=script&lang=js&"
export * from "./CardCreateSlugError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77341d86",
  null
  
)

export default component.exports